<template>
  <div class="dialog-playback-wrap">
    <div v-if="ocxSuccess" id="playWndPreview" class="dialog-playback"></div>
    <div v-else class="ocx-error">
      <img src="@/assets/common/ocx_error.png" />
      <div v-show="!ocxSuccess">
        <p style="margin: 16px 0; font-size: 18px; color: #1a1a1a;">
          控件未安装或加载失败
        </p>
        <p>若未安装成功，请下载安装控件</p>
        <p>
          若已安装控件，请先尝试重启浏览器重试当前操作；若问题仍然存在，建议检查网络或重新安装控件。
        </p>
        <p>
          <span
            v-if="downloadUrlSuccess"
            class="download-ocx"
            style="cursor: pointer"
            @click="jumpToDownload"
          >
            <i class="h-icon-download"></i>
            <span>下载浏览器控件</span>
          </span>
          <span v-else class="download-ocx" style="cursor: not-allowed; color: #999;">
            <i class="h-icon-download"></i>
            <span>下载浏览器控件</span>
          </span>
        </p>
      </div>
      <!-- <p v-show="!requestContinue" style="margin: 16px 0; font-size: 18px; color: #1a1a1a;">
        该监控点未配置录像计划
      </p> -->
    </div>
  </div>
</template>

<script>
// import commonApi from '@/api/common.api'
import ocxMixins from './mixins/ocxMixins'
const RESPONSETYPE = {
  STOP: 'StopPreview',
  ALARMPUSH: 'AlarmPush',
  START: 'StartPreview'
}

export default {
  name: 'PreviewOcx',
  mixins: [ocxMixins],
  props: {
    params: {
      type: Object,
      default() {
        return {}
      }
    },
    toolbar: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      playLoading: true,
      language: 'zh_CN',
      skin: 'redblack',
      link: '',
      ocxType: 'emmspreviewwebclient', // previewwebclient
      el: 'playWndPreview',
      componentMenuId: '010100',
      // 播放需要的额外参数
      extraData: {
        component_name: 'plugin',
        title_name: '',
        request_protocol: '',
        vnsc_mls_url: '',
        cas_url: '',
        bic_url: '',
        log_url: '',
        ncg_url: '',
        dms_url: '',
        vms_web_url: '',
        route_id: '',
        cas_tgt: '',
        language: 'zh_CN',
        skin: 'redblack',
        user_index_code: ''
      },
      videoArguments: {} // 传给控件的参数
    }
  },
  computed: {
    playStatus() {
      return this.isInitPlay ? 'initialize' : 'startpreview'
    }
  },
  watch: {
    params(value) {
      this.playVideo([this.formatVideoParams(this.params)])
    }
  },
  methods: {
    /**
     * @author liujie22
     * @desc 推送事件
     */
    handleSend(responseMsg) {
      // message {indexcode: xxxx, msg: {"send":"StopPreview"} / {"send":"AlarmPush"} / {"send": "StartPreview"}}
      const msg = typeof responseMsg.msg === 'string' ? responseMsg.msg : ''
      let emitType = ''
      let pic = ''
      // 预览关闭,需要将data中数据清除
      if (msg.indexOf(RESPONSETYPE.STOP) !== -1) {
        emitType = RESPONSETYPE.STOP
      } else if (msg.indexOf(RESPONSETYPE.ALARMPUSH) !== -1) {
        emitType = RESPONSETYPE.ALARMPUSH
        pic = responseMsg.pic
      } else if (msg.indexOf(RESPONSETYPE.START) !== -1) {
        emitType = RESPONSETYPE.START
      }
      emitType &&
        this.$emit('handleSend', { type: emitType, indexCode: responseMsg.indexcode, pic }) // 注册noticeParent事件，对外广播，params是需要传输的参数
    },
    /**
     * @author xuzilong
     * @desc 获取控件下载链接
     */
    getOcxDownLoadUrl() {
      this.$confirm('检测到您未安装视频播放控件，无法播放视频，是否前往下载?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question'
      }).then(() => {
        this.jumpToDownload()
      })
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-27 14:21:01
     * @Desc: 跳转到插件下载页面
     */
    jumpToDownload() {
      window.open('/emms/PluginDownload')
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-23 10:32:10
     * @Desc: 对播放视频数据额外数据封装
     */
    formatVideoParams(params) {
      return {
        camera_type: 0,
        transType: 1,
        is_cascaded: 0,
        cameraName: params.cameraName,
        cameraIndexCode: params.cameraIndexCode,
        serial_number: params.serialNumber,
        private_key: params.privateKey,
        ezviz_token: params.ezvizToken,
        channel_no: params.channelNo,
        device_type: 'ezviz_net'
      }
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-21 14:32:55
     * @Desc: 播放视频
     */
    playVideo(playData) {
      // ocx实例存在
      if (this.ocxPlay) {
        !this.extraData.app_key && (this.extraData.app_key = this.params.ysKey)
        this.videoArguments = { ...this.extraData, data: playData }
        !this.isInitPlay &&
          this.ocxPlay.request({
            funcName: 'VSSClient',
            arguments: { ...this.videoArguments, cmd_type: this.playStatus }
          })
      }
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-24 17:35:23
     * @Desc: 关闭视频
     */
    closeVideo() {
      if (this.ocxPlay) {
        this.ocxPlay.request({
          funcName: 'VSSClient',
          arguments: { cmd_type: 'stoppreview' }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-playback-wrap {
  &,
  .dialog-playback {
    width: 100%;
    height: 100%;
  }

  .ocx-error {
    padding-top: 40px;
    text-align: center;
    img {
      width: 240px;
      height: 200px;
    }
    p {
      font-size: 16px;
    }
  }
  .download-ocx {
    display: block;
    margin-top: 16px;
    i {
      font-size: 24px;
      vertical-align: middle;
    }
    span {
      font-family: 'Microsoft Yahei';
      vertical-align: middle;
    }
  }
}
</style>
